import { SchoolDetail } from "@interfaces/school"

export * from "./BootcampBanner"
export * from "./BootcampAlumnus"
export * from "./BootcampNavigator"
export * from "./BootcampOverview"
export * from "./BootcampOutcomes"
export * from "./BootcampVideo"
export * from "./BootcampSlider"
export * from "./BootcampSpecialization"
export * from "./BootcampCurriculum"
export * from "./BootcampTutors"
export * from "./BootcampLearnMethod"
export * from "./BootcampTestimonial"
export * from "./BootcampPortfolio"
export * from "./BootcampComparison"
export * from "./BootcampSchedule"
export * from "./BootcampFee"
export * from "./BootcampRegistrations"
export * from "./BootcampPayments"
export * from "./BootcampFaq"
export * from "./RelatedBootcamp"
export * from "./BootcampCommunity"
export * from "./TestimonialVideoRow"

export interface BootcampComponentProps {
  schoolDetail: SchoolDetail
}

